import { DemographicOption, ServiceOption, TreatmentType } from "../models/TreatmentProviders.models";
import { BasicNeedsKeywords } from "./BasicNeedKeywords";
import { ConsumerServices } from "./ConsumerServices";
import { CriminalJusticeAndLegalServices } from "./CriminalJusticeAndLegalServices";
import { Education } from "./Education";
import { EnvironmentAndPublicHealthSafety } from "./EnvironmentAndPublicHealthSafety";
import { IncomeSupportAndEmployment } from "./IncomeSupportAndEmployment";
import { IndividualAndFamilyLife } from "./IndividualAndFamilyLife";
import { OrganizationalCommunityInternationalServices } from "./OrganizationalCommunityInternationServices";

// Define a type for the overall configuration
interface TreatmentConfiguration {
  serviceList: ServiceOption[];
  demographicList: DemographicOption[];
}
// Define the type for the configuration object
export type TreatmentConfigurations = Record<TreatmentType, TreatmentConfiguration>;

const toKeywordObjects = (strings: string[]) => strings.map(s => ({keyword: s}));

const residentialServies = toKeywordObjects(["residential", "ambulatory", "partial", "hospitalization"]);
const outpatientServices = toKeywordObjects(['outpatient', 'ambulatory']);

const co_occuring_careServices = toKeywordObjects(["medically", "monitored", "hiv", "pregnant", "co-occuring"]);
const detoxServices = toKeywordObjects(['detox']);
const matServices = toKeywordObjects(['medically', 'monitored', 'opioid', 'maintenance']);
const recoveryHousingServices = toKeywordObjects(['housing']);
const faithBasedServices = toKeywordObjects(['christ', 'christ-centered', 'faith', 'faith-based']);

const adolescentDemographic = ['adolescent', 'child', 'children', 'child/adolescent'];
const adultDemo = ["adult"];
const veteranDemo = ['veteran', 'veterans', 'va'];


export const treatmentConfigurations: TreatmentConfigurations = {
  [TreatmentType.MentalHealth]: {
    serviceList: [
      { label: "Residential", value: residentialServies },
      { label: "Outpatient", value: outpatientServices }
    ],
    demographicList: [
      { label: "Adolescent", value: adolescentDemographic },
      { label: "Adult", value: adultDemo },
      { label: "Veteran", value: veteranDemo }
    ]
  },
  [TreatmentType.Prevention]: {
    serviceList: [
      { label: "Co-occuring Care", value: co_occuring_careServices },
      { label: "Residential", value: residentialServies },
      { label: "Outpatient", value: outpatientServices },
      { label: "Detox", value: detoxServices },
      { label: "MAT", value: matServices },
      { label: "Recovery Housing", value: recoveryHousingServices },
      { label: "Faith Based Services", value: faithBasedServices }
    ],
    demographicList: [
      { label: "Adolescent", value: ['adolescent'] },
      { label: "Adult", value: ['adult'] },
      { label: "Female", value: ['female'] },
      { label: "Male", value: ['male'] },
      { label: "Women and Children", value: ["woman", "children", "women", "child"] },
      { label: "Veteran", value: ['veteran', 'veterans', 'va'] }
    ]
  },
  [TreatmentType.SubstanceUse]: {
    serviceList: [
      { label: "Co-occuring Care", value: co_occuring_careServices },
      { label: "Residential", value: residentialServies },
      { label: "Outpatient", value: outpatientServices },
      { label: "Detox", value: detoxServices },
      { label: "MAT", value: matServices },
      { label: "Recovery Housing", value: recoveryHousingServices },
      { label: "Faith Based Services", value: faithBasedServices }
    ],
    demographicList: [
      { label: "Adolescent", value: ['adolescent'] },
      { label: "Adult", value: ['adult'] },
      { label: "Female", value: ['female', "woman", "women"] },
      { label: "Male", value: ['male'] },
      { label: "Women and Children", value: ["woman", "children", "women", "child"] },
      { label: "Veteran", value: ['veteran', 'veterans', 'va'] }
    ]
  },
  [TreatmentType.DropOff]: undefined,
  [TreatmentType.CrisisCenters]: undefined,
  [TreatmentType._211Resources]: {
    serviceList: [
      CriminalJusticeAndLegalServices,
      EnvironmentAndPublicHealthSafety,
      IncomeSupportAndEmployment,
      ConsumerServices,
      Education,
      IndividualAndFamilyLife,
      OrganizationalCommunityInternationalServices,
      BasicNeedsKeywords
    ],
    demographicList: []
  },
  [TreatmentType.VAMedicalCenter]: undefined,
  [TreatmentType.HealthServies]: {
    serviceList: [],
    demographicList: []
  },
  [TreatmentType.SupportGroups]: {
    serviceList: [],
    demographicList: []
  }
};



